




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

import { ListItem, SkeletonBox } from '@/layouts/components'

import { Invoice, Order } from '@/models'

import InvoicePaymentMethodChip from './InvoicePaymentMethodChip.vue'

import { isFood } from '@/utils'

@Component({
  components: {
    ListItem,
    InvoicePaymentMethodChip,
    SkeletonBox
  }
})
export default class InvoiceTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly invoice!: Invoice

  get locations () {
    return this.invoiceLocations(this.invoice)
  }

  get invoiceTileTitle () {
    return isFood() ? 'Comanda' : 'Compra'
  }

  @Getter('ordering/invoiceLocations')
  readonly invoiceLocations!: (invoice: Invoice) => string[] | null

  @Getter('ordering/ordersByInvoiceId')
  readonly ordersByInvoiceId!: (id: number) => Order[]

  @Action('ordering/loadFirstOrder')
  loadFirstOrder!: (id: number) => Promise<void>

  created () {
    if (this.ordersByInvoiceId(this.invoice.id).length === 0) {
      this.loadOrder()
    }
  }

  async loadOrder () {
    try {
      await this.loadFirstOrder(this.invoice.id)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
